<template>
    <div id="trs-main" class="page-agreement">
        <div class="container">
            <div class="box panel-agreement">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * @author HungNS
 */
export default {
    name: "NewsWrapper"
}
</script>

<style scoped>
@media only screen and (min-width: 768px) and (max-width: 1199px) {
    #trs-wrapper .container, .container-md, .container-sm {
        max-width: none !important;
    }
}
</style>
